import { render, staticRenderFns } from "./BroadcastDashboard.vue?vue&type=template&id=46f3f31f&scoped=true&"
import script from "./BroadcastDashboard.vue?vue&type=script&lang=js&"
export * from "./BroadcastDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastDashboard.vue?vue&type=style&index=0&id=46f3f31f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f3f31f",
  null
  
)

export default component.exports